import { z } from "zod";
function objectKeys(subject) {
    const result = new Array();
    for (const key of Object.keys(subject)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result.push(key);
    }
    return result;
}
export var MrvEventType;
(function (MrvEventType) {
    MrvEventType["Arrival"] = "Arrival";
    MrvEventType["Departure"] = "Departure";
    MrvEventType["ArrivalSTS"] = "ArrivalSTS";
    MrvEventType["DepartureSTS"] = "DepartureSTS";
    MrvEventType["STS"] = "STS";
    MrvEventType["Noon"] = "Noon";
})(MrvEventType || (MrvEventType = {}));
function getTonnesOfConsumptionData(data) {
    if (data == null) {
        return 0;
    }
    let result = 0;
    for (const key of objectKeys(data)) {
        result += readPropertyNumber(key, data);
    }
    return result;
}
export function getTonnesOfMrvEventConsumption(data) {
    if (data == null) {
        return 0;
    }
    let result = 0;
    for (const key of objectKeys(data)) {
        result += getTonnesOfMrvEventConsumptionProperty(key, data);
    }
    return result;
}
function getTonnesOfMrvEventConsumptionProperty(key, data) {
    switch (key) {
        case "mainEngines": {
            return getTonnesOfConsumptionData(data.mainEngines ?? null);
        }
        case "auxEngines": {
            return getTonnesOfConsumptionData(data.auxEngines ?? null);
        }
        case "boilers": {
            return getTonnesOfConsumptionData(data.boilers ?? null);
        }
        case "inertGasGeneratorsAndCombustionUnits": {
            return getTonnesOfConsumptionData(data.inertGasGeneratorsAndCombustionUnits ?? null);
        }
        case "incinerators": {
            return data.incinerators?.o_tonnes ?? 0;
        }
    }
}
function readPropertyNumber(key, data) {
    switch (key) {
        case "hfo_tonnes":
            return data.hfo_tonnes ?? 0;
        case "lfo_tonnes":
            return data.lfo_tonnes ?? 0;
        case "mgo_tonnes":
            return data.mgo_tonnes ?? 0;
        case "mdo_tonnes":
            return data.mdo_tonnes ?? 0;
        case "lpgp_tonnes":
            return data.lpgp_tonnes ?? 0;
        case "lpgb_tonnes":
            return data.lpgb_tonnes ?? 0;
        case "lng_tonnes":
            return data.lng_tonnes ?? 0;
        case "m_tonnes":
            return data.m_tonnes ?? 0;
        case "e_tonnes":
            return data.e_tonnes ?? 0;
        case "o_tonnes":
            return data.o_tonnes ?? 0;
        case "o_type":
            return 0;
    }
}
export const ConsumptionData = z.object({
    hfo_tonnes: z.optional(z.number()),
    lfo_tonnes: z.optional(z.number()),
    mgo_tonnes: z.optional(z.number()),
    mdo_tonnes: z.optional(z.number()),
    lpgp_tonnes: z.optional(z.number()),
    lpgb_tonnes: z.optional(z.number()),
    lng_tonnes: z.optional(z.number()),
    m_tonnes: z.optional(z.number()),
    e_tonnes: z.optional(z.number()),
    o_tonnes: z.optional(z.number()),
    o_type: z.optional(z.string()),
});
export const MrvEventConsumption = z.object({
    mainEngines: z.optional(ConsumptionData),
    auxEngines: z.optional(ConsumptionData),
    boilers: z.optional(ConsumptionData),
    inertGasGeneratorsAndCombustionUnits: z.optional(ConsumptionData),
    incinerators: z.optional(z.object({
        o_tonnes: z.optional(z.number()),
        o_type: z.optional(z.string()),
    })),
});
//# sourceMappingURL=MrvEventConsumption.js.map